<template>
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.6875 2.21875C16.875 2.40625 17 2.65625 17 2.9375V10C17 11.125 16.0938 12 15 12H9C7.875 12 7 11.125 6.96875 10V2C6.96875 0.90625 7.84375 0 8.96875 0H14.0625C14.3438 0 14.5938 0.125 14.7812 0.3125L16.6875 2.21875ZM15.5 10H15.4688V4H14C13.4375 4 13 3.5625 13 3L12.9688 1.53125H8.96875C8.6875 1.53125 8.46875 1.75 8.46875 2.03125V10C8.46875 10.2812 8.6875 10.5 8.96875 10.5H15C15.25 10.5 15.5 10.2812 15.5 10ZM9.5 14V13H11V14C11 15.125 10.0938 16 9 16H3C1.875 16 1 15.125 1 14L0.96875 6C0.96875 4.90625 1.875 4 2.96875 4H6V5.53125H2.96875C2.71875 5.53125 2.46875 5.75 2.46875 6.03125V14C2.46875 14.2812 2.6875 14.5 2.96875 14.5H9C9.25 14.5 9.5 14.2812 9.5 14Z"
      :fill="props.fill"
    />
  </svg>
</template>

<script setup>
import { defineProps } from 'vue';
const props = defineProps({
  fill: {
    type: String,
    default: '#0074D9',
  },
});
</script>
